import style from './trainers-section.module.scss'
import { ImagePublicFileId } from '../image/image-public-file-id'
import { useTrainerModalContext } from '../../context/trainer-modal-context'
import { Container, Row } from 'react-bootstrap'
import Carousel, { ArrowProps } from 'react-multi-carousel'
import { trainersConfig } from 'src/component/trainers-section/trainers-config'
import { SectionTitle } from 'src/component/ui/section-title'
import { BackArrowSvgIcon } from 'src/component/util/images'
import { Trainer } from 'src/dao/core-dao'
import { useTrainers } from 'src/hook/use-trainers'
import 'react-multi-carousel/lib/styles.css'

const TrainerCard = ({ trainer }: { trainer: Trainer }): React.ReactElement => {
  const { openTrainer } = useTrainerModalContext()

  const handleClick = (): void => {
    openTrainer(trainer.id, trainer)
  }

  return (
    <div
      onClick={handleClick}
      className={style.trainerCard}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleClick()
        }
      }}
    >
      <ImagePublicFileId
        fileId={trainer.mediumProfilePhotoPublicFileId}
        className={style.trainerImage}
        data-testid="trainer-image"
      />
      <h5 className={style.trainerName}>{trainer.firstName}</h5>
    </div>
  )
}

const LeftArrow = (props: ArrowProps): React.ReactElement => {
  return (
    <button {...props} className={`${style.carouselArrow} ${style.carouselArrowLeft}`}>
      <BackArrowSvgIcon className={style.carouselIcon} data-testid="back-arrow-icon" />
    </button>
  )
}

const RightArrow = (props: ArrowProps): React.ReactElement => {
  return (
    <button {...props} className={`${style.carouselArrow} ${style.carouselArrowRight}`}>
      <BackArrowSvgIcon className={`${style.carouselIcon} ${style.carouselIconRight}`} data-testid="back-arrow-icon" />
    </button>
  )
}
export const TrainersSection = (): React.ReactElement => {
  const { data: trainers = [] } = useTrainers()

  return (
    <Container className={style.trainersSectionContainer} data-testid="container">
      <Row className="d-flex justify-content-center align-items-center" data-testid="row">
        <SectionTitle>Grndhouse trainers</SectionTitle>
      </Row>
      <Carousel
        swipeable
        draggable={false}
        responsive={trainersConfig.carouselResponsive}
        infinite
        keyBoardControl
        customLeftArrow={<LeftArrow />}
        customRightArrow={<RightArrow />}
        customTransition="transform 500ms ease-in-out"
        shouldResetAutoplay={false}
        rewind={false}
      >
        {trainers && trainers.map((trainer) => <TrainerCard trainer={trainer} key={trainer.id} />)}
      </Carousel>
    </Container>
  )
}
